import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { UIContextProvider } from './context/ui.context';
import { AuthProvider } from './context/user.context';
import {InstanceContextProvider} from './context/instanceContext'
import { CookiesProvider } from 'react-cookie';
import queryString from 'query-string';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { initializeKeycloak } from './keycloak';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Complete the code exchange and callback URL cleanup before mounting the router.
void initializeKeycloak().then(authenticated => {
  if (!authenticated) throw new Error('Keycloak authentication failed')
  root.render(
    <>
      <BrowserRouter>
        <UIContextProvider>
          <CookiesProvider>
            <AuthProvider>
              <InstanceContextProvider>
                <QueryParamProvider
                  options={{
                    searchStringToObject: queryString.parse,
                    objectToSearchString: queryString.stringify,
                  }}
                  adapter={ReactRouter6Adapter}
                >
                  <App />
                </QueryParamProvider>
              </InstanceContextProvider>
            </AuthProvider>
          </CookiesProvider>
        </UIContextProvider>
      </BrowserRouter>
    </>
  );
}).catch(() => {
  console.error('Keycloak initialization failed')
  root.render(
    <div role="alert">
      <p>Unable to sign in. Please try again.</p>
      <button onClick={() => window.location.reload()}>Try again</button>
    </div>
  )
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
